import get from 'lodash/get'

export const getInlineFieldEditing = (state) => get(state, ['vegetation', 'inlineField', 'fieldName'])
export const getInlineFieldValue = (state) => get(state, ['vegetation', 'inlineField', 'value'])



// WEBPACK FOOTER //
// ./src/modules/vegetation/selectors/inlineField.js